import { Link, useLocation } from 'react-router-dom';
import { 
  Home, User, FileText, Building2, Settings, 
  HelpCircle, Receipt, CreditCard, LayoutGrid
} from 'lucide-react';
import { cn } from "@/lib/utils";

interface SidebarNavigationProps {
  isOpen: boolean;
  isMobile: boolean;
}

export function SidebarNavigation({ isOpen, isMobile }: SidebarNavigationProps) {
  const location = useLocation();
  
  const navigationItems = [
    { icon: Home, label: 'Dashboard', path: '/dashboard' },
    { icon: User, label: 'Profile', path: '/dashboard/profile' },
    { icon: FileText, label: 'Documents', path: '/dashboard/documents' },
    { icon: Building2, label: 'Business', path: '/dashboard/business' },
    { icon: FileText, label: 'Tax Return', path: '/dashboard/tax-return' },
    { icon: CreditCard, label: 'Payments', path: '/dashboard/payments' },
    { icon: LayoutGrid, label: 'Services', path: '/dashboard/services' },
    { icon: Settings, label: 'Settings', path: '/dashboard/settings' },
    { icon: HelpCircle, label: 'Support', path: '/dashboard/support' },
  ];

  return (
    <nav className="flex-1 overflow-y-auto py-4">
      <div className="space-y-1 px-3">
        {navigationItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "flex items-center gap-3 px-3 py-2 text-sm font-medium rounded-lg transition-colors",
                "hover:bg-accent hover:text-accent-foreground",
                isActive 
                  ? "bg-[#D3E4FD] text-primary" 
                  : "text-muted-foreground",
                !isOpen && !isMobile && "justify-center px-2"
              )}
              title={!isOpen && !isMobile ? item.label : undefined}
            >
              <item.icon className={cn(
                "h-5 w-5 shrink-0",
                isActive && "text-primary"
              )} />
              {(isOpen || isMobile) && <span>{item.label}</span>}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}